var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnificationlensicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0605 26.9537L21.623 21.5162M24.5605 14.4537C24.5605 19.9765 20.0834 24.4537 14.5605 24.4537C9.0377 24.4537 4.56055 19.9765 4.56055 14.4537C4.56055 8.93083 9.0377 4.45367 14.5605 4.45367C20.0834 4.45367 24.5605 8.93083 24.5605 14.4537Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnificationlensicon);
export default __webpack_public_path__ + "static/media/magnificationlensicon.c9968307e8f5218b2a5fc67d73533cc6.svg";
export { ForwardRef as ReactComponent };